import Action from '../Action';
import SignupStatsService from '../../services/SignupStatsService.js';
import { message } from 'antd';

export function fetchSignupStats(value) {
	const body = { startDate: value[0]?._d, endDate: value[1]?._d };
	return (dispatch) => {
		SignupStatsService.fetchSignupStats(body)
			.then((data) => {
				dispatch({ type: Action.FETCH_SIGNUP_STATS, signupStats: data.data });
				message.success('Fetched SignupStats');
			})
			.catch((error) => message.error('Failed to get SignupStats!'));
	};
}
